import 'react';
import isFunction from '../../utils/isFunction.js';
import { useDialog, DialogProvider } from './context.js';
import { jsx } from '@emotion/react';
import '@indeed/ihl-use-id';
import '../../hooks/useControllableState.js';
import '../../utils/warn.js';
import '../../hooks/useIsMobile.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';

const Dialog = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const context = useDialog(props);
  const {
    isOpen,
    toggle
  } = context;
  const dialogChildren = isFunction(children) ? children({
    isOpen,
    toggle
  }) : children;
  return jsx(DialogProvider, {
    value: context
  }, dialogChildren);
};
Dialog.displayName = "Dialog";

export { Dialog };
